import { toggleClass } from './helpers';

const mobileMenuButton = document.querySelector('.menu-mobile-button');
const mobileMenuBlock = document.querySelector('.menu-main-mobile');

export const handleOpenMenu = () => {
  mobileMenuButton.addEventListener('click', () => {
    toggleClass(mobileMenuButton, 'opened');
    toggleClass(mobileMenuBlock, 'opened');
  });
};
